import { AIChatProvider, useAIChat } from "./AIChatContext";
import { ChatFullscreenModal } from "./ChatFullscreenModal";
import styles from "./ChatSidebar.module.css";
import { ChatSidebarControls } from "./ChatSidebarControls";
import { ChatSidebarMainContent } from "./ChatSidebarMainContent";

interface ChatSidebarProps {
  onClose: () => void;
}

const ChatSidebarContent = ({ onClose }: ChatSidebarProps) => {
  const { isFullscreen } = useAIChat();

  return (
    <>
      <ChatFullscreenModal open={isFullscreen} onClose={onClose} />
      <div className={styles.container}>
        <ChatSidebarControls onClose={onClose} />
        <ChatSidebarMainContent />
      </div>
    </>
  );
};

export const ChatSidebar = ({ onClose }: ChatSidebarProps) => {
  return (
    <AIChatProvider>
      <ChatSidebarContent onClose={onClose} />
    </AIChatProvider>
  );
};
